/**
 * Blog article : sommaire auto (H2), cartes CTA inline, sticky CTA metafields.
 * Amélioration progressive — sans JS, l'article reste lisible.
 */
(function () {
  'use strict';

  var PLCH_CTA_DEFAULTS = {
    collectionLabel: 'Voir la collection \u2192',
    productLabel: 'Voir le produit \u2192',
    collectionKicker: 'La collection',
    productKicker: 'Le produit',
    maxCollections: 2,
    maxProducts: 1
  };

  var PLCH_STICKY_DEFAULTS = {
    collectionLabel: 'Voir les inspirations \u2192',
    productLabel: 'Voir le produit \u2192'
  };

  var STICKY_MOBILE_MQ = window.matchMedia('(max-width: 989px)');
  var FETCH_TIMEOUT_MS = 8000;
  var HANDLE_RE = /^[a-z0-9-]+$/;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/"/g, '&quot;');
  }

  /** Liens internes http(s) uniquement — rejette javascript:, data:, domaines tiers. */
  function sanitizeHref(raw) {
    if (!raw) return null;
    try {
      var url = new URL(String(raw), window.location.origin);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
      if (url.hostname !== window.location.hostname) return null;
      return url.toString();
    } catch (e) {
      return null;
    }
  }

  /** Images Shopify CDN ou même origine — évite l'injection via réponses JSON altérées. */
  function sanitizeImageSrc(raw) {
    if (!raw) return null;
    var normalized = String(raw);
    if (normalized.indexOf('//') === 0) {
      normalized = window.location.protocol + normalized;
    }
    try {
      var url = new URL(normalized, window.location.origin);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
      if (url.hostname === window.location.hostname) return url.toString();
      if (url.hostname === 'cdn.shopify.com' || /\.shopify(cdn)?\.com$/i.test(url.hostname)) {
        return url.toString();
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  function buildAriaLabel(label, title) {
    return label.replace(/\s*\u2192\s*$/, '').trim() + ' : ' + title;
  }

  function styleBodyImages(body) {
    var formatter = body.querySelector('rte-formatter') || body;
    formatter.querySelectorAll('img').forEach(function (img, index) {
      img.classList.add(
        index % 2 === 0 ? 'plch-blog-article__img--primary' : 'plch-blog-article__img--secondary'
      );
    });
  }

  function slugify(text) {
    var raw = (text || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    var slug = raw.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return slug || 'section';
  }

  function getBody(root) {
    return root.querySelector('[data-plch-blog-body]');
  }

  function initArticle(root) {
    var body = getBody(root);
    var tocNav = root.querySelector('[data-plch-toc]');
    var tocList = root.querySelector('[data-plch-toc-list]');
    var tocDetails = root.querySelector('[data-plch-toc-details]');
    var backLabel = root.getAttribute('data-plch-back-toc-label') || '';

    if (body) styleBodyImages(body);
    if (!body || !tocNav || !tocList) return;

    var headings = body.querySelectorAll('h2');
    if (headings.length < 2) {
      tocNav.setAttribute('hidden', '');
      tocNav.classList.add('plch-blog-article__toc--empty');
      return;
    }

    tocNav.removeAttribute('hidden');
    tocNav.classList.remove('plch-blog-article__toc--pending', 'plch-blog-article__toc--empty');

    var usedIds = new Set();
    body.querySelectorAll('[id]').forEach(function (el) {
      usedIds.add(el.id);
    });

    headings.forEach(function (h2, index) {
      var id = h2.id;
      if (!id) {
        var base = slugify(h2.textContent || '');
        var candidate = base;
        var n = 1;
        while (usedIds.has(candidate)) candidate = base + '-' + n++;
        id = candidate;
        h2.id = id;
        usedIds.add(id);
      }

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = (h2.textContent || '').trim();
      li.appendChild(a);
      tocList.appendChild(li);

      if (backLabel && headings.length >= 4 && index >= 1) {
        var jump = document.createElement('p');
        jump.className = 'plch-blog-article__section-jump';
        var back = document.createElement('a');
        back.href = '#' + tocNav.id;
        back.textContent = backLabel;
        jump.appendChild(back);
        h2.insertAdjacentElement('afterend', jump);
      }
    });

    if (tocDetails && window.matchMedia('(min-width: 750px)').matches) {
      tocDetails.open = true;
    }
  }

  function readCtaConfig(root) {
    var d = root.dataset;
    var mc = parseInt(d.plchCtaMaxCollections, 10);
    var mp = parseInt(d.plchCtaMaxProducts, 10);
    return {
      collectionLabel: d.plchCtaCollectionLabel || PLCH_CTA_DEFAULTS.collectionLabel,
      productLabel: d.plchCtaProductLabel || PLCH_CTA_DEFAULTS.productLabel,
      collectionKicker: d.plchCtaCollectionKicker || PLCH_CTA_DEFAULTS.collectionKicker,
      productKicker: d.plchCtaProductKicker || PLCH_CTA_DEFAULTS.productKicker,
      maxCollections: isNaN(mc) ? PLCH_CTA_DEFAULTS.maxCollections : Math.max(0, mc),
      maxProducts: isNaN(mp) ? PLCH_CTA_DEFAULTS.maxProducts : Math.max(0, mp)
    };
  }

  function parseTarget(anchor) {
    var raw = anchor.getAttribute('href') || '';
    if (!raw || raw.charAt(0) === '#') return null;
    if (raw.indexOf('[') !== -1 || /URL_INTERNE/i.test(raw)) return null;

    var url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch (e) {
      return null;
    }
    if (url.hostname !== window.location.hostname) return null;

    var parts = url.pathname.split('/').filter(Boolean);
    var pIdx = parts.indexOf('products');
    if (pIdx !== -1 && parts[pIdx + 1] && HANDLE_RE.test(parts[pIdx + 1])) {
      return { type: 'product', handle: parts[pIdx + 1], url: url };
    }
    var cIdx = parts.indexOf('collections');
    if (cIdx !== -1 && parts[cIdx + 1] && HANDLE_RE.test(parts[cIdx + 1])) {
      return { type: 'collection', handle: parts[cIdx + 1], url: url };
    }
    return null;
  }

  function anchorBlock(anchor, body) {
    var block = anchor.closest('p, blockquote, li, td, th');
    return block && body.contains(block) && block !== body ? block : null;
  }

  function isAfterLastH2(block, body) {
    var headings = body.querySelectorAll('h2');
    if (!headings.length) return false;
    var last = headings[headings.length - 1];
    return !!(last.compareDocumentPosition(block) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function withWidth(src, width) {
    var safe = sanitizeImageSrc(src);
    if (!safe) return null;
    try {
      var u = new URL(safe);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return safe;
    }
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number' || !isFinite(cents)) return '';
    try {
      var currency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      var locale = document.documentElement.lang || 'fr';
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(
        cents / 100
      );
    } catch (e) {
      return '';
    }
  }

  function fetchJson(url) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer =
      controller &&
      window.setTimeout(function () {
        controller.abort();
      }, FETCH_TIMEOUT_MS);

    return fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (response) {
        if (timer) window.clearTimeout(timer);
        if (!response.ok) return Promise.reject(new Error('HTTP ' + response.status));
        return response.json();
      })
      .catch(function (err) {
        if (timer) window.clearTimeout(timer);
        throw err;
      });
  }

  function buildPlaceholder() {
    var aside = document.createElement('aside');
    aside.className = 'plch-inline-cta';
    aside.setAttribute('data-state', 'loading');
    aside.innerHTML =
      '<div class="plch-inline-cta__link" aria-hidden="true">' +
      '<div class="plch-inline-cta__media"></div>' +
      '<div class="plch-inline-cta__body">' +
      '<span class="plch-inline-cta__skeleton-line"></span>' +
      '<span class="plch-inline-cta__skeleton-line plch-inline-cta__skeleton-line--title"></span>' +
      '<span class="plch-inline-cta__skeleton-line plch-inline-cta__skeleton-line--btn"></span>' +
      '</div></div>';
    return aside;
  }

  function normalizeCardData(data, target) {
    if (!data || typeof data.title !== 'string') return null;

    var url = sanitizeHref(data.url) || sanitizeHref(target.url.toString());
    if (!url) return null;

    var images = Array.isArray(data.images) ? data.images : [];
    if (!images.length && data.featured_image) {
      images = [data.featured_image];
    }

    images = images.map(sanitizeImageSrc).filter(Boolean).slice(0, 4);
    if (!images.length) return null;

    return {
      title: data.title,
      url: url,
      images: images,
      price: typeof data.price === 'number' ? data.price : null
    };
  }

  function renderCard(aside, card, target, cfg) {
    var isProduct = target.type === 'product';
    var label = isProduct ? cfg.productLabel : cfg.collectionLabel;
    var kicker = isProduct ? cfg.productKicker : cfg.collectionKicker;
    var ariaLabel = buildAriaLabel(label, card.title);

    var mosaic =
      '<span class="plch-inline-cta__mosaic plch-inline-cta__mosaic--' + card.images.length + '">';
    card.images.forEach(function (src) {
      var sized = withWidth(src, 360);
      if (!sized) return;
      mosaic +=
        '<img class="plch-inline-cta__tile" src="' +
        escapeAttr(sized) +
        '" alt="" loading="lazy" decoding="async">';
    });
    mosaic += '</span>';

    var priceHtml = '';
    if (isProduct && card.price != null) {
      var money = formatMoney(card.price);
      if (money) {
        priceHtml = '<span class="plch-inline-cta__price">' + escapeHtml(money) + '</span>';
      }
    }

    aside.innerHTML =
      '<a class="plch-inline-cta__link" href="' +
      escapeAttr(card.url) +
      '" aria-label="' +
      escapeAttr(ariaLabel) +
      '">' +
      '<span class="plch-inline-cta__media">' +
      mosaic +
      '<span class="plch-inline-cta__scrim" aria-hidden="true"></span>' +
      '<span class="plch-inline-cta__button button" aria-hidden="true">' +
      escapeHtml(label) +
      '</span></span>' +
      '<span class="plch-inline-cta__body">' +
      '<span class="plch-inline-cta__kicker">' +
      escapeHtml(kicker) +
      '</span>' +
      '<span class="plch-inline-cta__title">' +
      escapeHtml(card.title) +
      '</span>' +
      priceHtml +
      '</span></a>';
    aside.setAttribute('data-state', 'ready');
  }

  function loadCard(aside, target, cfg) {
    var url;
    if (target.type === 'product') {
      url = target.url.origin + target.url.pathname.replace(/\/$/, '') + '.js';
    } else {
      var collectionUrl = new URL(target.url.toString());
      collectionUrl.hash = '';
      collectionUrl.searchParams.set('view', 'card');
      url = collectionUrl.toString();
    }

    fetchJson(url)
      .then(function (data) {
        if (target.type === 'collection' && data && data.ok === false) {
          aside.remove();
          return;
        }
        var card = normalizeCardData(data, target);
        if (!card) {
          aside.remove();
          return;
        }
        renderCard(aside, card, target, cfg);
      })
      .catch(function () {
        aside.remove();
      });
  }

  function initCtaCards(root) {
    if (root.dataset.plchCtaInit) return;
    root.dataset.plchCtaInit = '1';

    var body = getBody(root);
    if (!body || !('IntersectionObserver' in window) || typeof window.fetch !== 'function') return;

    var cfg = readCtaConfig(root);
    if (!cfg.maxCollections && !cfg.maxProducts) return;

    var links = body.querySelectorAll('a[href]');
    if (!links.length) return;

    var seen = Object.create(null);
    var counts = { collection: 0, product: 0 };
    var max = { collection: cfg.maxCollections, product: cfg.maxProducts };
    var lastBlock = null;
    var lastCard = null;
    var loadMap = new Map();

    links.forEach(function (anchor) {
      var target = parseTarget(anchor);
      if (!target) return;

      var key = target.type + ':' + target.handle;
      if (seen[key] || counts[target.type] >= max[target.type]) return;

      var block = anchorBlock(anchor, body);
      if (!block || isAfterLastH2(block, body)) return;
      if (block === lastBlock) return;
      if (lastCard && block.previousElementSibling === lastCard) return;

      seen[key] = true;
      counts[target.type] += 1;

      var placeholder = buildPlaceholder();
      block.insertAdjacentElement('afterend', placeholder);
      lastBlock = block;
      lastCard = placeholder;
      loadMap.set(placeholder, target);
    });

    if (!loadMap.size) return;

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          obs.unobserve(entry.target);
          var target = loadMap.get(entry.target);
          if (target) loadCard(entry.target, target, cfg);
        });
      },
      { rootMargin: '300px 0px' }
    );

    loadMap.forEach(function (_target, el) {
      observer.observe(el);
    });
  }

  function readStickyConfig(root) {
    var node = root.querySelector('[data-plch-sticky-config]');
    if (!node) return null;

    var data;
    try {
      data = JSON.parse(node.textContent || '');
    } catch (e) {
      return null;
    }

    if (!data || (data.type !== 'collection' && data.type !== 'product')) return null;
    if (typeof data.title !== 'string' || !data.title.trim()) return null;

    var url = sanitizeHref(data.url);
    if (!url) return null;

    var image = data.image ? sanitizeImageSrc(data.image) : null;
    var price = typeof data.price === 'number' && isFinite(data.price) ? data.price : null;

    return { type: data.type, title: data.title.trim(), url: url, image: image, price: price };
  }

  function initStickyCta(root) {
    if (root.dataset.plchStickyInit) return;

    var cfg = readStickyConfig(root);
    if (!cfg) return;
    root.dataset.plchStickyInit = '1';

    var isCollection = cfg.type === 'collection';
    var label = isCollection
      ? root.dataset.plchStickyCollectionLabel || PLCH_STICKY_DEFAULTS.collectionLabel
      : root.dataset.plchStickyProductLabel || PLCH_STICKY_DEFAULTS.productLabel;
    var ariaLabel = buildAriaLabel(label, cfg.title);

    var shell = document.createElement('div');
    shell.className = 'plch-sticky-cta';
    shell.hidden = true;

    var barLinkClass =
      'plch-sticky-cta__bar-link' + (isCollection ? ' plch-sticky-cta__bar-link--collection' : '');
    var barInner = '';

    if (!isCollection && cfg.image) {
      barInner +=
        '<img class="plch-sticky-cta__bar-thumb" src="' +
        escapeAttr(cfg.image) +
        '" alt="" loading="lazy" decoding="async" width="48" height="48">';
    }

    barInner +=
      '<span class="plch-sticky-cta__bar-text">' +
      '<span class="plch-sticky-cta__bar-title">' +
      escapeHtml(cfg.title) +
      '</span>';

    if (!isCollection && cfg.price != null) {
      var money = formatMoney(cfg.price);
      if (money) {
        barInner += '<span class="plch-sticky-cta__bar-price">' + escapeHtml(money) + '</span>';
      }
    }

    barInner +=
      '</span>' +
      '<span class="plch-sticky-cta__bar-button button" aria-hidden="true">' +
      escapeHtml(label) +
      '</span>';

    shell.innerHTML =
      '<div class="plch-sticky-cta__bar">' +
      '<a class="' +
      barLinkClass +
      '" href="' +
      escapeAttr(cfg.url) +
      '" aria-label="' +
      escapeAttr(ariaLabel) +
      '">' +
      barInner +
      '</a></div>' +
      '<aside class="plch-sticky-cta__rail" aria-label="' +
      escapeAttr(ariaLabel) +
      '">' +
      '<a class="plch-sticky-cta__rail-link" href="' +
      escapeAttr(cfg.url) +
      '">' +
      escapeHtml(label) +
      '</a>' +
      '<span class="plch-sticky-cta__rail-context">' +
      escapeHtml(cfg.title) +
      '</span></aside>';

    document.body.appendChild(shell);

    var bridge = document.querySelector('[data-plch-article-bridge]');
    var bridgeVisible = false;
    var scrolledEnough = false;
    var scrollThreshold = 0.25;

    function syncVisibility() {
      var show = scrolledEnough && !bridgeVisible;
      shell.hidden = !show;
      shell.classList.toggle('is-visible', show);
      document.body.classList.toggle('plch-sticky-cta-active', show && STICKY_MOBILE_MQ.matches);
    }

    function updateScrollGate() {
      var body = getBody(root);
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var docHeight = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      var ratio = scrollY / docHeight;

      if (body) {
        var rect = body.getBoundingClientRect();
        var bodyTop = scrollY + rect.top;
        var bodyHeight = body.offsetHeight || rect.height;
        if (bodyHeight > 0) {
          ratio = (scrollY - bodyTop + window.innerHeight * 0.15) / bodyHeight;
        }
      }

      scrolledEnough = ratio >= scrollThreshold;
      syncVisibility();
    }

    if (bridge && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          bridgeVisible = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          syncVisibility();
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0 }
      ).observe(bridge);
    }

    var scrollTicking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(function () {
          scrollTicking = false;
          updateScrollGate();
        });
      },
      { passive: true }
    );

    if (typeof STICKY_MOBILE_MQ.addEventListener === 'function') {
      STICKY_MOBILE_MQ.addEventListener('change', syncVisibility);
    } else if (typeof STICKY_MOBILE_MQ.addListener === 'function') {
      STICKY_MOBILE_MQ.addListener(syncVisibility);
    }

    updateScrollGate();
  }

  function init() {
    document.querySelectorAll('[data-plch-blog-article]').forEach(function (root) {
      initArticle(root);
      try {
        initCtaCards(root);
      } catch (e) {
        /* Les cartes CTA ne doivent jamais casser l'article. */
      }
      try {
        initStickyCta(root);
      } catch (e) {
        /* Idem pour le sticky CTA. */
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
